<template>
	<tr>
		<td class="px-3 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
			<span v-if="alreadyBid">{{ __("Bid Placed") }}</span>
			<span v-else>
				<ui-check-group
					:form="form"
					:field="'matches.' + idx + '.input.placeBid'"
					v-model="checkedOffer"
					label="New"
					@change="updateSuggestedPrice()"
				/>
			</span>
		</td>
		<td class="px-3 py-3 text-sm text-gray-500">
			{{
				$cropOptions.getLocalizedLabel(
					match.offer.user.type,
					$cropOptions.companyTypeOptions
				)
			}}
		</td>
		<td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500">
			{{
				$cropOptions.getLocalizedLabel(
					match.offer.product.grade,
					$cropOptions.productGradeOptions
				)
			}}
			<br />
			{{ match.offer.product.harvest }}
		</td>
		<td class="px-3 py-3 text-sm text-gray-500">
			{{ match.offer.location.address.city }}
		</td>
		<td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500">
			<span v-if="match.distance_km_road"
				>{{ match.distance_km_road.toFixed(0) }} km</span
			>
		</td>
		<td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500" v-if="canBid">
			<ui-input-group
				suffix="€/t"
				:form="form"
				:field="'matches.' + idx + '.freight_cost_eur'"
				v-model="match.freight_cost_eur"
				:dp="2"
				:noLabel="true"
				:required="true"
				:disabled="!checkedOffer"
				@input="updateSuggestedPrice(match)"
			/>
		</td>
		<td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500" v-if="canBid">
			<ui-input-group
				suffix="t"
				:form="form"
				:field="'matches.' + idx + '.input.qty__mt'"
				v-if="match.offer.qty.partial_ok"
				class="min-w-[5rem]"
				v-model="match.input.qty__mt"
				:dp="0"
				:noLabel="true"
				:disabled="!checkedOffer"
				:required="true"
			/>
			<span v-else>
				{{ match.input.qty__mt }} t
				<ui-tooltip class="ml-2" :text="__('Partial quantity not desired')" />
			</span>
		</td>
		<td
			class="px-3 py-3 whitespace-nowrap text-sm text-gray-500"
			v-if="checkedOffer"
		>
			<ui-input-group
				suffix="€/t"
				:form="form"
				:field="'matches.' + idx + '.input.price__mt'"
				class="min-w-[7rem]"
				v-model="match.input.price__mt"
				:key="'IG_MATCH_PRICE_MT_' + idx + '__' + match.input.price__mt"
				:noLabel="true"
				:required="true"
				:disabled="true"
				:dp="2"
				v-if="priceType == 'FLAT'"
			/>
			<ui-input-group
				suffix="€/t"
				:form="form"
				:field="'matches.' + idx + '.input.price__basis'"
				class="min-w-[7rem]"
				v-model="match.input.price__basis"
				:key="'IG_MATCH_PRICE_BASIS_' + idx + '__' + match.input.price__basis"
				:noLabel="true"
				:required="true"
				:disabled="true"
				:dp="2"
				v-else-if="priceType == 'BASIS'"
			/>
			<ui-input-group
				suffix="€/t"
				:form="form"
				:field="'matches.' + idx + '.input.price__basis'"
				class="min-w-[7rem]"
				v-model="match.input.price__basis"
				:key="'IG_MATCH_PRICE_INDEXED_' + idx + '__' + match.input.price__basis"
				:noLabel="true"
				:required="true"
				:disabled="true"
				:dp="2"
				v-else-if="priceType == 'INDEXED'"
			/>
		</td>
		<td
			class="px-3 py-3 whitespace-nowrap text-sm text-gray-500"
			v-if="checkedOffer && ['INDEXED', 'BASIS'].includes(priceType)"
		>
			<ui-input-group
				suffix="€/t"
				:form="form"
				:field="'matches.' + idx + '.input.price__basis'"
				class="min-w-[7rem]"
				v-model="currentPriceIndication"
				:key="
					'IG_MATCH_PRICE_INDEXED_CURRENT_INDICATION' +
					idx +
					'__' +
					match.input.price__basis
				"
				:noLabel="true"
				:required="true"
				:disabled="true"
				:dp="2"
			/>
		</td>
		<td
			class="px-3 py-3 text-sm text-gray-500"
			v-if="alreadyBid && lastTradable"
		>
			<div class="flex flex-col gap-y-1 min-w-[7rem]">
				<span
					>Status:
					{{
						__(
							$cropOptions.getLabel(
								thread.status,
								$cropOptions.threadStatusOptions
							)
						)
					}}</span
				>

				<ui-button
					class="flex gap-x-1 items-center px-2"
					type="secondary"
					v-on:click="
						$inertia.visit($route('threads', { active_id: thread.id }))
					"
				>
					{{ __("To negotiation") }}
					<!-- <ui-icon name="chevron-right" stroke="2" class="-mr-2 w-5 h-5" /> -->
				</ui-button>
			</div>
		</td>
		<td
			class="px-3 py-3 whitespace-nowrap text-sm text-gray-500"
			v-if="alreadyBid && lastTradable"
		>
			<div class="min-w-[7rem]">{{ lastTradable.qty.mt }} t</div>
		</td>

		<td
			class="px-3 py-3 whitespace-nowrap text-sm text-gray-500"
			v-if="alreadyBid && lastTradable"
		>
			<div class="min-w-[7rem]">
				<span v-if="lastTradable.price.type == 'FLAT'">
					{{ lastTradable.price.mt }} €/t
				</span>
				<span v-else-if="lastTradable.price.type == 'INDEXED'">
					Basis:
					<br />
					{{ lastTradable.price.basis }} €/t
				</span>
			</div>
		</td>
		<td
			class="px-3 py-3 whitespace-nowrap text-sm text-gray-500"
			v-if="alreadyBid && lastTradable && lastTradable.price.type == 'INDEXED'"
		>
			<div class="min-w-[7rem]">{{ lastTradable.price.mt }} €/t</div>
		</td>
	</tr>
</template>

<script>
export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
		match: {
			type: Object,
			required: true,
		},
		idx: {
			type: Number,
			required: true,
		},
		bidsToBeSubmitted: {
			type: Object,
			required: true,
		},
	},
	data() {
		let threads = this.offer.matches.results[this.idx].threads,
			alreadyBid = threads.filter((t) => t.status != "CLOSED").length > 0;

		return {
			threads: threads,
			alreadyBid: alreadyBid,
			canBid: !alreadyBid,
			checkedOffer: this.form.matches[this.idx].input.placeBid,
			input: this.match.input,
		};
	},
	computed: {
		thread() {
			let threads = this.threads.filter((t) => t.status != "CLOSED");
			return threads.length > 0 ? threads[0] : null;
		},
		lastTradable() {
			let threads = this.match.threads.filter((t) => t.status != "CLOSED");
			if (threads.length > 0) {
				return threads[0].last_tradable ?? threads[0].lastTradable;
			} else {
				return null;
			}
		},
		priceType() {
			return this.match.input.price__type;
		},
		currentPriceIndication() {
			let cf = this.offer.commodityFuture;
			if (cf) {
				let price = 1 * cf.euronext_price + 1 * this.match.input.price__basis;
				return price.toFixed(2);
			} else {
				return "";
			}
		},
	},
	methods: {
		updateSuggestedPrice() {
			if (this.priceType == "FLAT") {
				let newPrice = this.offer.price.mt - this.match.freight_cost_eur;
				this.match.input.price__mt = newPrice ? "" + newPrice.toFixed(2) : null;
			} else if (this.priceType == "BASIS") {
				let newBasisPrice =
					this.offer.price.basis - this.match.freight_cost_eur;
				this.match.input.price__basis = newBasisPrice
					? "" + newBasisPrice.toFixed(2)
					: null;
			} else if (this.priceType == "INDEXED") {
				let newBasisPrice =
					this.offer.price.basis - this.match.freight_cost_eur;
				this.match.input.price__basis = newBasisPrice
					? "" + newBasisPrice.toFixed(2)
					: null;
			}
		},
	},
	watch: {
		checkedOffer() {
			this.form.matches[this.idx].input.placeBid = this.checkedOffer;
		},
		input: {
			handler(newValue) {
				this.bidsToBeSubmitted.number = this.form.matches.filter(
					(m) => m.input.placeBid == true
				).length;
			},
			deep: true,
			immediate: true,
		},
	},
};
</script>
